// Shared layout tokens for the ClientHub client pages — one place for the card
// chrome and rhythm that was copy-pasted across the hub panels, so a spacing or
// surface decision is made once. See .local/docs/clienthub-client-layout/design-tokens.md
// for where each value was measured.

// One card level. This is EXACTLY the string the panels carried before the
// extraction, so a panel that adopts it renders unchanged (layout.test.js pins it).
export const SURFACE = 'bg-white dark:bg-gray-900 rounded-xl shadow-sm border dark:border-gray-800 p-5';

// Furniture — the standing facts a person reads without thinking: flat, dense, no
// card chrome. Opaque so scrolling content never shows through the sticky header.
export const FURNITURE = 'bg-white dark:bg-gray-950 border-b border-gray-200 dark:border-gray-800';

// The loud element (Activity): the one surface allowed a heavier border and shadow,
// because the page is otherwise a single card level.
export const STREAM = 'bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-md p-5 md:p-6';

// House page padding (frontend CLAUDE.md) — furniture that goes full-bleed re-applies it itself.
export const PAGE_PAD = 'px-4 md:px-6 lg:px-10';

// Rhythm: one gap between zones and between the two body columns, a tighter one
// inside a zone. Measured ~21 CSS px between zones in the mockup.
export const RHYTHM = {
  zone: 'gap-5',
  zoneStack: 'space-y-5',
  intra: 'gap-3',
  intraStack: 'space-y-3',
};

// Body: main column + a fixed right rail from `lg`, one column below it. The rail is
// 360px at lg and 400px from xl, where the owner suggestion's "N messages · N% answered"
// line needs the room to stay on one line beside its Accept button.
export const BODY_GRID = 'grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] xl:grid-cols-[minmax(0,1fr)_400px] gap-5';

// The sticky client header sets --client-header-h (see ClientDetailLayout); anything
// scrolled to under it (the composer) clears it plus a little air.
export const ANCHOR_OFFSET = 'scroll-mt-[calc(var(--client-header-h,0px)+1rem)]';
